import { forwardRef } from "react";

import {
  ForwardedCategorySelectTreeAdapter,
  CategorySelectTreeAdapterProps,
} from "./ForwardedCategorySelectTreeAdapter";

/**
 * Компонент-обертка для ForwardedCategorySelectTreeAdapter
 * Используется для корректной работы с Controller из react-hook-form
 */
export const ForwardedCategorySelectTreeAdapterWrapper = forwardRef<
  HTMLDivElement,
  CategorySelectTreeAdapterProps
>((props, ref) => {
  return <ForwardedCategorySelectTreeAdapter {...props} ref={ref} />;
});

// Добавляем displayName для лучшей отладки
ForwardedCategorySelectTreeAdapterWrapper.displayName =
  "ForwardedCategorySelectTreeAdapterWrapper";
